(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      const topBar = document.querySelector('.top-bar-wrapper');
      const headerHeight = this.header.offsetHeight + (topBar ? topBar.offsetHeight : 0);
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  // ===== Overtone Universal Mega Menu =====
  (function initOvertoneMega() {
    const mega = document.getElementById('OvertoneMega');
    const nav = document.querySelector('[data-ot-header-nav]');
    if (!mega || !nav) return;

    const triggers = Array.from(nav.querySelectorAll('[data-ot-nav-trigger]'));
    const panels = Array.from(mega.querySelectorAll('[data-ot-mega-panel]'));
    const shopCats = Array.from(mega.querySelectorAll('[data-ot-shop-cat]'));
    let closeTimer = null;

    const activate = (index) => {
      const activeIndex = String(index);
      triggers.forEach((trigger) => {
        const on = trigger.dataset.otNavTrigger === activeIndex;
        trigger.classList.toggle('is-active', on);
        trigger.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      let activePanel = null;
      panels.forEach((panel) => {
        const on = panel.dataset.otMegaPanel === activeIndex;
        panel.classList.toggle('is-active', on);
        if (on) activePanel = panel;
      });
      mega.classList.toggle('is-standard', activePanel && activePanel.dataset.otPanelKind === 'standard');
    };

    const open = (index) => {
      clearTimeout(closeTimer);
      if (index !== undefined) activate(index);
      mega.classList.add('is-open');
      mega.setAttribute('aria-hidden', 'false');
    };

    const close = () => {
      closeTimer = setTimeout(() => {
        mega.classList.remove('is-open');
        mega.setAttribute('aria-hidden', 'true');
        triggers.forEach((trigger) => {
          trigger.classList.remove('is-active');
          trigger.setAttribute('aria-expanded', 'false');
        });
      }, 140);
    };

    triggers.forEach((trigger) => {
      const index = trigger.dataset.otNavTrigger;
      trigger.addEventListener('mouseenter', () => open(index));
      trigger.addEventListener('focus', () => open(index));
      trigger.addEventListener('mouseleave', close);
    });

    mega.addEventListener('mouseenter', () => open());
    mega.addEventListener('mouseleave', close);

    shopCats.forEach((cat) => {
      const activateCollection = () => {
        const panel = cat.closest('[data-ot-mega-panel]');
        if (!panel) return;
        const handle = cat.dataset.otShopCat;
        panel.querySelectorAll('[data-ot-shop-cat]').forEach((item) => {
          const on = item === cat;
          item.classList.toggle('is-active', on);
          item.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panel.querySelectorAll('[data-ot-shop-panel]').forEach((collectionPanel) => {
          collectionPanel.classList.toggle('is-active', collectionPanel.dataset.otShopPanel === handle);
        });
      };
      cat.addEventListener('mouseenter', activateCollection);
      cat.addEventListener('focus', activateCollection);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
    });
  })();

  (function initOvertoneMobileDrawer() {
    const drawer = document.querySelector('[data-ot-mobile-drawer]');
    if (!drawer) return;

    const closeDrawer = () => {
      drawer.open = false;
      document.body.classList.remove('ot-mobile-drawer-open');
    };

    drawer.addEventListener('toggle', () => {
      document.body.classList.toggle('ot-mobile-drawer-open', drawer.open);
    });

    drawer.querySelectorAll('[data-ot-mobile-close]').forEach((button) => {
      button.addEventListener('click', closeDrawer);
    });

    drawer.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.open) closeDrawer();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
